import { Injectable } from '@angular/core';
import { Mailgroup, MailGroupDetails } from './mailgroup';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class MailgroupService {

  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) { }
  

  getmailgroups(): Observable<Mailgroup[]> {

    return this.httpClient.get<Mailgroup[]>(this.baseUrl + '/api/MailGroupApi');

  }
  AddMailGroup(mailgroup: Mailgroup) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');

    return this.httpClient.post(this.baseUrl + '/api/MailGroupApi/Add', mailgroup, { headers: header, observe: 'response' })
  }
  PutMailGroup(mailgroup: Mailgroup) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put(this.baseUrl + 'api/MailGroupApi/Update', mailgroup, { headers: header, observe: 'response' })
  }
  Delete(mailgroup: Mailgroup) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/MailGroupApi/activeordeactive', mailgroup, { headers: header, observe: 'response' })
  }
  postMailgroupMapping(mailgroupmap) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/MailGroupApi/PostMailgroupMapping', mailgroupmap, { headers: header, observe: 'response' })
  }
  GetMailGrpMappedList(mailgroupid): Observable<any[]> {
    return this.httpClient.get<any[]>(this.baseUrl + 'api/MailGroupApi/GetById?id=' + mailgroupid);
  }
  DeleteUserFromGroup(user: MailGroupDetails) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/MailGroupApi/InActiveUserFromGroup', user, { headers: header, observe: 'response' })

  }
}
